import { InventoryItemStatusEnum, InventoryMovementTypeEnum, InventoryUnitEnum } from '@restavo/shared/enums/inventory';

export { InventoryItemStatusEnum, InventoryMovementTypeEnum, InventoryUnitEnum };

export const InventoryMovementTypes = [
  { label: 'inventoryMovementTypes.receive', value: InventoryMovementTypeEnum.RECEIVE },
  { label: 'inventoryMovementTypes.usage', value: InventoryMovementTypeEnum.USAGE },
  { label: 'inventoryMovementTypes.waste', value: InventoryMovementTypeEnum.WASTE },
  { label: 'inventoryMovementTypes.adjust', value: InventoryMovementTypeEnum.ADJUST },
];

export const InventoryItemStatuses = [
  { label: 'inventoryItemStatuses.active', value: InventoryItemStatusEnum.ACTIVE },
  { label: 'inventoryItemStatuses.archived', value: InventoryItemStatusEnum.ARCHIVED },
];

export const InventoryUnits = [
  { label: 'inventoryUnits.kg', value: InventoryUnitEnum.KG },
  { label: 'inventoryUnits.g', value: InventoryUnitEnum.G },
  { label: 'inventoryUnits.l', value: InventoryUnitEnum.L },
  { label: 'inventoryUnits.ml', value: InventoryUnitEnum.ML },
  { label: 'inventoryUnits.pcs', value: InventoryUnitEnum.PCS },
  { label: 'inventoryUnits.box', value: InventoryUnitEnum.BOX },
];

export function getMovementTypeText(type: InventoryMovementTypeEnum | number) {
  if (type === InventoryMovementTypeEnum.RECEIVE) return 'inventoryMovementTypes.receive';
  if (type === InventoryMovementTypeEnum.USAGE) return 'inventoryMovementTypes.usage';
  if (type === InventoryMovementTypeEnum.WASTE) return 'inventoryMovementTypes.waste';
  return 'inventoryMovementTypes.adjust';
}

export function getMovementTypeColor(type: InventoryMovementTypeEnum | number) {
  if (type === InventoryMovementTypeEnum.RECEIVE) return 'green';
  if (type === InventoryMovementTypeEnum.USAGE) return 'blue';
  if (type === InventoryMovementTypeEnum.WASTE) return 'red';
  return 'warm-gray';
}

export const inventoryMovementTypeOptions = InventoryMovementTypes.map((item) => ({
  id: item.value,
  text: item.label,
}));

export function formatQuantity(quantity: number | string, unit: string) {
  const value = Number(quantity) || 0;
  return `${parseFloat(value.toFixed(3))} ${unit}`.trim();
}
